export default "__VITE_ASSET__766baacd__"